import { Projection } from 'ol/proj';
import { getArea } from 'ol/sphere';
import { useCallback } from 'react';
import useDefaultsCache from '../useDefaultsCache';
var DEFAULT_PROJECTION_UNIT_IN_METERS = 'm';
var DEFAULT_PROJECTION_CODE = 'EPSG:3857';

/**
 * @returns getGeometryArea - returns area of the geometry
 * @returns getGeometryAreaWithMeterSquare - returns area of the geometry and square metre text
 */
export function useGeometryArea() {
  var {
    cachedDefaults
  } = useDefaultsCache();
  var getGeometryArea = useCallback(geometry => {
    var _cachedDefaults$proje;

    if (!geometry) return '0';
    var projectionCode = (_cachedDefaults$proje = cachedDefaults === null || cachedDefaults === void 0 ? void 0 : cachedDefaults.projection.epsgName) !== null && _cachedDefaults$proje !== void 0 ? _cachedDefaults$proje : DEFAULT_PROJECTION_CODE;
    var extent = cachedDefaults === null || cachedDefaults === void 0 ? void 0 : cachedDefaults.projection.extent;
    var area = getArea(geometry, {
      projection: new Projection({
        units: DEFAULT_PROJECTION_UNIT_IN_METERS,
        code: projectionCode,
        extent
      })
    });
    return (Math.round(area * 100) / 100).toString();
  }, [cachedDefaults === null || cachedDefaults === void 0 ? void 0 : cachedDefaults.projection.epsgName, cachedDefaults === null || cachedDefaults === void 0 ? void 0 : cachedDefaults.projection.extent]);
  var getGeometryAreaWithSquareMetre = useCallback(geometry => {
    var area = getGeometryArea(geometry);
    return "".concat(area, " m\xB2");
  }, [getGeometryArea]);
  return {
    getGeometryArea,
    getGeometryAreaWithSquareMetre
  };
}